export const ServerGroupTemplates = {
  userData: require('../details/userData.html'),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/serverGroup/templates/index.ts